module.exports = __webpack_public_path__ + "img/TimeRange.5326326d.svg";